module.exports = __webpack_public_path__ + "static/media/interac-logo.6bc6b046.svg";